import React, { ChangeEvent, useState } from 'react';
import { CommentsOutsidePageEditor } from './CommentsOutsidePageEditor.component';

interface CommentsOutsidePageAddProps {
  rgzId?: string;
  handleSave: (options?: { scoreVersionId?: string }) => Promise<unknown>;
  canAddComment: boolean;
  isCommentOnCriterion: boolean;
  canAddCommentOnCriterion: boolean;
  canEditScore: boolean;
  canDeleteForcedComment: boolean;
}

export const CommentsOutsidePageAdd: React.FC<CommentsOutsidePageAddProps> = ({
  rgzId,
  handleSave,
  canAddComment,
  isCommentOnCriterion,
  canAddCommentOnCriterion,
  canEditScore,
  canDeleteForcedComment
}) => {
  return (
    <CommentsOutsidePageEditor
      commentProp={''}
      onSave={handleSave}
      isActionVisible={false}
      rgzId={rgzId}
      commentId={''}
      canAddComment={canAddComment}
      isCommentOnCriterion={isCommentOnCriterion}
      canAddCommentOnCriterion={canAddCommentOnCriterion}
      canEditScore={canEditScore}
      canDeleteForcedComment={canDeleteForcedComment}
    />
  );
};
